class HalloweenTheme {
  constructor(){
    this.body=document.body;
    this.overlay=document.querySelector('[data-drawer-overlay]');
    this.cartDrawer=document.querySelector('[data-cart-drawer]');
    this.navDrawer=document.querySelector('[data-nav-drawer]');
    this.initDrawers();
    this.initCartForms();
    this.initQuantity();
    this.initAnimations();
    this.initCountdowns();
    this.initProductForms();
    this.initPdpGallery();
    this.initStickyAtc();
  }
  initDrawers(){
    document.addEventListener('click',(e)=>{
      const opener=e.target.closest('[data-open-drawer]');
      if(opener){e.preventDefault();this.openDrawer(opener.dataset.openDrawer);}
      const closer=e.target.closest('[data-close-drawer]');
      if(closer){e.preventDefault();this.closeDrawers();}
    });
    this.overlay?.addEventListener('click',()=>this.closeDrawers());
    document.addEventListener('keydown',(e)=>{if(e.key==='Escape')this.closeDrawers();});
  }
  openDrawer(type){
    this.closeDrawers(false);
    const drawer=type==='cart'?this.cartDrawer:this.navDrawer;
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden','false');
    this.overlay?.classList.add('is-open');
    this.body.classList.add('no-scroll');
  }
  closeDrawers(removeOverlay=true){
    this.cartDrawer?.classList.remove('is-open');
    this.navDrawer?.classList.remove('is-open');
    this.cartDrawer?.setAttribute('aria-hidden','true');
    this.navDrawer?.setAttribute('aria-hidden','true');
    if(removeOverlay){this.overlay?.classList.remove('is-open');this.body.classList.remove('no-scroll');}
  }
  async refreshCart(open=true){
    try{
      const r=await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart=await r.json();
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
      const body=this.cartDrawer?.querySelector('[data-cart-drawer-body]');
      const footer=this.cartDrawer?.querySelector('[data-cart-drawer-footer]');
      if(body){
        body.innerHTML=cart.items.length?cart.items.map(item=>`
          <div class="drawer-item" data-line-key="${item.key}">
            <a class="drawer-item__image" href="${item.url}">${item.image?`<img src="${item.image}${item.image.includes('?')?'&':'?'}width=180" alt="${this.escape(item.product_title)}">`:''}</a>
            <div><a href="${item.url}"><strong>${this.escape(item.product_title)}</strong></a><div class="muted" style="font-size:.78rem">${item.variant_title&&item.variant_title!=='Default Title'?this.escape(item.variant_title):''}</div><div class="price">${this.money(item.final_line_price)}</div><div class="qty" style="margin-top:8px"><button type="button" data-cart-change="${item.key}" data-qty="${Math.max(0,item.quantity-1)}">−</button><input value="${item.quantity}" readonly aria-label="Antal"><button type="button" data-cart-change="${item.key}" data-qty="${item.quantity+1}">+</button></div></div>
            <button class="icon-button" type="button" data-cart-change="${item.key}" data-qty="0" aria-label="Ta bort">×</button>
          </div>`).join(''):`<div class="empty-state"><div style="font-size:3rem">◌</div><h3>Din varukorg är tom.</h3><p class="muted">Börja med våra utvalda Halloween-produkter.</p><a class="button" href="${window.Shopify.routes.root}collections/all">Shoppa kollektionen</a></div>`;
      }
      if(footer){footer.querySelector('[data-cart-total]').textContent=this.money(cart.total_price);this.updateFreeShipping(cart.total_price);}
      if(open)this.openDrawer('cart');
    }catch(err){console.error(err)}
  }
  money(cents){
    try{return new Intl.NumberFormat(document.documentElement.lang||'sv-SE',{style:'currency',currency:window.themeCurrency||'SEK'}).format(cents/100)}
    catch(e){return `${(cents/100).toFixed(2)} kr`}
  }
  escape(str=''){return String(str).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[c]))}
  updateFreeShipping(total){
    document.querySelectorAll('[data-free-shipping]').forEach(box=>{
      const threshold=Number(box.dataset.threshold||0);
      const fill=box.querySelector('[data-progress-fill]');
      const msg=box.querySelector('[data-progress-message]');
      const remain=Math.max(0,threshold-total);
      if(fill)fill.style.width=`${threshold?Math.min(100,total/threshold*100):100}%`;
      if(msg)msg.textContent=remain>0?`${this.money(remain)} kvar till fri frakt`:'Fri frakt aktiverad';
    });
  }
  initCartForms(){
    document.addEventListener('submit',async(e)=>{
      const form=e.target.closest('form[data-ajax-product-form]');
      if(!form)return;
      e.preventDefault();
      const btn=form.querySelector('[type="submit"]');
      const structuredLabel=btn?.querySelector('[data-atc-label]');
      const originalLabel=structuredLabel?.textContent;
      const originalText=structuredLabel?null:btn?.textContent;
      if(btn){btn.disabled=true;btn.setAttribute('aria-busy','true');if(structuredLabel)structuredLabel.textContent='Lägger till…';else btn.textContent='Lägger till…';}
      try{
        const r=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        if(!r.ok)throw new Error('Kunde inte lägga till');
        await this.refreshCart(true);
      }catch(err){form.querySelector('[data-form-error]')?.replaceChildren(document.createTextNode('Kunde inte lägga till produkten. Försök igen.'));}
      finally{if(btn){btn.disabled=false;btn.removeAttribute('aria-busy');if(structuredLabel)structuredLabel.textContent=originalLabel;else btn.textContent=originalText;}}
    });
    document.addEventListener('click',async(e)=>{
      const b=e.target.closest('[data-cart-change]');
      if(!b)return;
      const key=b.dataset.cartChange;
      const quantity=Number(b.dataset.qty);
      b.disabled=true;
      try{
        await fetch(`${window.Shopify.routes.root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
        await this.refreshCart(false);
      }finally{b.disabled=false;}
    });
  }
  initQuantity(){
    document.addEventListener('click',(e)=>{
      const b=e.target.closest('[data-qty-button]');
      if(!b)return;
      const wrap=b.closest('[data-quantity]');
      const input=wrap?.querySelector('input');
      if(!input)return;
      const n=Math.max(1,Number(input.value||1)+(b.dataset.qtyButton==='plus'?1:-1));
      input.value=n;
    });
  }
  initAnimations(){
    const items=[...document.querySelectorAll('.animate-in')];
    if(!items.length)return;
    if(!('IntersectionObserver'in window)){items.forEach(x=>x.classList.add('is-visible'));return;}
    items.forEach(x=>x.classList.add('will-animate'));
    const io=new IntersectionObserver(es=>es.forEach(x=>{if(x.isIntersecting){x.target.classList.add('is-visible');io.unobserve(x.target)}}),{threshold:.08,rootMargin:'0px 0px 80px'});
    items.forEach(x=>io.observe(x));
  }
  initCountdowns(){
    document.querySelectorAll('[data-countdown]').forEach(el=>{
      const end=new Date(el.dataset.countdown);if(isNaN(end))return;
      const tick=()=>{
        const d=end-Date.now();
        if(d<=0){el.querySelectorAll('[data-time]').forEach(x=>x.textContent='00');return;}
        const vals={days:Math.floor(d/86400000),hours:Math.floor(d/3600000)%24,minutes:Math.floor(d/60000)%60,seconds:Math.floor(d/1000)%60};
        Object.entries(vals).forEach(([k,v])=>{const n=el.querySelector(`[data-time="${k}"]`);if(n)n.textContent=String(v).padStart(2,'0')});
      };
      tick();setInterval(tick,1000);
    });
  }
  initProductForms(){
    document.querySelectorAll('[data-product-root]').forEach(root=>{
      const json=root.querySelector('[data-product-json]');if(!json)return;
      let product;try{product=JSON.parse(json.textContent)}catch(e){return}
      const form=root.querySelector('form[data-ajax-product-form]');
      const idInput=form?.querySelector('[name="id"]');
      const price=root.querySelector('[data-product-price]');
      const compare=root.querySelector('[data-product-compare]');
      const save=root.querySelector('[data-product-save]');
      const submit=form?.querySelector('[type="submit"]');
      const atcLabel=submit?.querySelector('[data-atc-label]');
      const atcPrice=submit?.querySelector('[data-atc-price]');
      const options=[...root.querySelectorAll('[data-option-index]')];
      const sync=()=>{
        const values=options.map(group=>group.querySelector('input:checked')?.value);
        const variant=options.length?product.variants.find(v=>v.options.every((opt,i)=>opt===values[i])):(product.variants.find(v=>String(v.id)===String(idInput?.value))||product.variants[0]);
        options.forEach(group=>{const label=group.querySelector('[data-option-label]');const checked=group.querySelector('input:checked');if(label&&checked)label.textContent=checked.dataset.displayValue||checked.value;});
        if(!variant){
          if(submit)submit.disabled=true;
          if(atcLabel)atcLabel.textContent='Ej tillgänglig';
          if(atcPrice)atcPrice.textContent='';
          return;
        }
        if(idInput)idInput.value=variant.id;
        if(price)price.textContent=this.money(variant.price);
        if(compare){compare.textContent=variant.compare_at_price>variant.price?this.money(variant.compare_at_price):'';compare.style.display=variant.compare_at_price>variant.price?'inline':'none';}
        if(save){
          const hasSave=variant.compare_at_price>variant.price;
          save.textContent=hasSave?`Spara ${Math.round((variant.compare_at_price-variant.price)/variant.compare_at_price*100)}%`:'';
          save.style.display=hasSave?'inline-flex':'none';
        }
        document.querySelectorAll('[data-product-price-copy]').forEach(el=>el.textContent=this.money(variant.price));
        if(submit)submit.disabled=!variant.available;
        if(atcLabel)atcLabel.textContent=variant.available?(submit?.dataset.availableText||'Lägg i varukorg'):(submit?.dataset.soldoutText||'Slutsåld');
        if(atcPrice)atcPrice.textContent=this.money(variant.price);
        root.dispatchEvent(new CustomEvent('variant:change',{detail:{variant},bubbles:true}));
      };
      options.forEach(group=>group.addEventListener('change',sync));sync();
    });
  }

  initPdpGallery(){
    document.querySelectorAll('[data-pdp-gallery]').forEach(gallery=>{
      const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
      const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
      const prev=gallery.querySelector('[data-gallery-prev]');
      const next=gallery.querySelector('[data-gallery-next]');
      const current=gallery.querySelector('[data-gallery-current]');
      if(!slides.length)return;
      let index=Math.max(0,slides.findIndex(x=>x.classList.contains('is-active')));
      const show=(n)=>{
        index=(n+slides.length)%slides.length;
        slides.forEach((slide,i)=>{const active=i===index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',active?'false':'true');});
        thumbs.forEach((thumb,i)=>{thumb.classList.toggle('is-active',i===index);thumb.setAttribute('aria-current',i===index?'true':'false');});
        if(current)current.textContent=String(index+1);
        thumbs[index]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
      };
      if(slides.length<2){if(prev)prev.hidden=true;if(next)next.hidden=true;}
      prev?.addEventListener('click',()=>show(index-1));
      next?.addEventListener('click',()=>show(index+1));
      thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
      const root=gallery.closest('[data-product-root]');
      root?.querySelectorAll('[data-gallery-jump]').forEach(btn=>btn.addEventListener('click',()=>show(Number(btn.dataset.galleryJump||0))));
      const stage=gallery.querySelector('.pdp-gallery__stage');
      let startX=null;
      stage?.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse')return;startX=e.clientX;});
      stage?.addEventListener('pointerup',e=>{if(startX===null)return;const delta=e.clientX-startX;startX=null;if(Math.abs(delta)>45)show(index+(delta<0?1:-1));});

      const zoomButton=gallery.querySelector('[data-gallery-zoom]');
      const lightbox=gallery.querySelector('[data-gallery-lightbox]');
      const lightboxImage=gallery.querySelector('[data-gallery-lightbox-image]');
      const lightboxClose=gallery.querySelector('[data-gallery-lightbox-close]');
      const closeLightbox=()=>{
        if(!lightbox)return;
        lightbox.hidden=true;
        lightbox.setAttribute('aria-hidden','true');
        document.body.classList.remove('no-scroll');
      };
      const openLightbox=()=>{
        const activeImage=slides[index]?.querySelector('img');
        if(!activeImage||!lightbox||!lightboxImage)return;
        lightboxImage.src=activeImage.currentSrc||activeImage.src;
        lightboxImage.srcset=activeImage.srcset||'';
        lightboxImage.sizes='96vw';
        lightboxImage.alt=activeImage.alt||'';
        lightbox.hidden=false;
        lightbox.setAttribute('aria-hidden','false');
        document.body.classList.add('no-scroll');
        lightboxClose?.focus();
      };
      zoomButton?.addEventListener('click',openLightbox);
      lightboxClose?.addEventListener('click',closeLightbox);
      lightbox?.addEventListener('click',e=>{if(e.target===lightbox)closeLightbox();});
      document.addEventListener('keydown',e=>{if(e.key==='Escape'&&lightbox&&!lightbox.hidden)closeLightbox();});
      show(index);
    });
  }
  initStickyAtc(){
    const bar=document.querySelector('[data-sticky-atc]');
    const main=document.querySelector('[data-main-atc]');
    if(!bar||!main)return;
    const io=new IntersectionObserver(([entry])=>bar.classList.toggle('is-visible',!entry.isIntersecting),{threshold:.05});
    io.observe(main);
    const btn=bar.querySelector('button');
    btn?.addEventListener('click',()=>main.click());
    document.addEventListener('variant:change',(e)=>{const v=e.detail?.variant;const p=bar.querySelector('[data-sticky-price]');const bp=bar.querySelector('[data-sticky-button-price]');const label=bar.querySelector('[data-sticky-label]');if(v&&p)p.textContent=this.money(v.price);if(v&&bp)bp.textContent=this.money(v.price);if(v&&btn){btn.disabled=!v.available;if(label)label.textContent=v.available?'Lägg i varukorg':'Slutsåld';}});
  }

}
document.addEventListener('DOMContentLoaded',()=>new HalloweenTheme());
